module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch1",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('p', {
    staticClass: "SP"
  }), _vm._v(" "), _c('header', [_c('h1', {
    staticClass: "CN",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "11",
      "id": "pg_11",
      "role": "doc-pagebreak"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#c_ch1"
    }
  }, [_c('span', {
    staticClass: "cn"
  }, [_vm._v("1")]), _vm._v("        The Mission of Catholic Higher Education in the Age of the Corporatized University")])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO1"
  }, [_vm._v("My students and I were having an excellent semester in my course on economic ethics, or so I thought. The students seemed engaged, coming to each class eagerly prepared to partake in discussion. On one particular afternoon, I had a memorable conversation with a student from the class, who remains one of the most brilliant students I have ever taught (he later obtained a fellowship in a doctoral program in one of the hard sciences at an elite university). He told me that he was enjoying learning about Catholic social teaching on economic life, but he was doubtful of its relevance to “real-world” issues. Ever the candid conversation partner in addition to his intellectual acumen, Peter bluntly stated that he failed to see institutions actually trying to embody the principles of Catholic social teaching, including our own Catholic university."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-1",
      "id": "chapter1_1",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" In his view, if it is impossible or impractical for a Catholic university to implement CST, how can we think that secular institutions will do any better? Peter grew up a devout Catholic, but he had clearly grown tired of what he perceived as hypocrisy in church-related institutions. “Do as I say, not what I do” was no longer working for this bright and inquisitive young man.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Catholic institutions of higher learning must demonstrate their own willingness to implement the church’s social teaching, such as its insistence on the human dignity and rights of all, in order to preserve its credibility. Over the years, numerous students have candidly stated that learning about Catholic social teaching is pointless when they fail to see Catholic institutions living up to the tradition’s own ideals. Others have sat in my office and expressed their dissatisfaction, and sometimes despair, over what they perceive to be the university’s reduction of the ideals of Catholic social teaching to mere rhetoric. Students often recognize when food service and janitorial staff are not paid living wages. Many are deeply disturbed by this fact, as well as by the shockingly low wages of adjuncts and the resistance to unions on Catholic campuses, despite the church’s "), _c('span', {
    attrs: {
      "aria-label": "12",
      "id": "pg_12",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("full support of the right to just wages and unions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-2",
      "id": "chapter1_2",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Such violations of the church’s own social teachings often challenge the faith of Catholic students. As theologian Johannes Baptist Metz has argued, many young Christians yearn for a church that adopts more “radicalism” in the struggle for social justice and less “doctrinal rigorism.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-3",
      "id": "chapter1_3",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" In recent decades, one out of three baptized Catholics has left the church, often citing “hypocrisy” and “other moral failures” as reasons."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-4",
      "id": "chapter1_4",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" While many young Catholics either remain disillusioned with the church or have abandoned it altogether, research also shows that young Catholics want to know that their faith makes a difference in the world."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-5",
      "id": "chapter1_5",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Dean Hoge concludes in his study of young adult Catholics that “if the relationship between social justice and a specifically Catholic identity were more immediate to young adult Catholics, their perspective might be more concerned with structural approaches, aggregate effects, power and institutional systems—in keeping with contemporary church teaching regarding social justice.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-6",
      "id": "chapter1_6",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Thus, confronting injustices on our campuses and illuminating how CST positively influences our institutions is vital to the faith formation of our students. Although this book focuses on Catholic colleges and universities, it also has implications for Christian universities of all types, as young Christians from many denominations often leave their churches in search of more socially progressive communities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-7",
      "id": "chapter1_7",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By virtue of their identity and mission, Catholic universities are urged to promote Catholic social teaching and to consider its prescriptions for a more just and peaceful world."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-8",
      "id": "chapter1_8",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" As the United States Conference of Catholic Bishops (USCCB) has stated, “if Catholic education and formation fail to communicate our social tradition, they are not fully Catholic.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-9",
      "id": "chapter1_9",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" The aim is not simply to transmit knowledge, but to help shape the minds and hearts of our students so they can transform the world for the better."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-10",
      "id": "chapter1_10",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" In other words, we should seek to aid them in conscience formation. If teaching CST is to have this kind of transformative effect on our students, Catholic educators and institutions must move from talk to action. Modeling the ideals of the Catholic social tradition is even more important than teaching these ideals in the classroom. The late Catholic ethicist William Spohn trenchantly discussed the formation of students’ consciences, maintaining that “we learn that a wise, compassionate, and committed life is possible from the living witnesses whom we know. The ideals that guide conscience do not reside in the starry heavens but in "), _c('span', {
    attrs: {
      "aria-label": "13",
      "id": "pg_13",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("actual people we admire.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-11",
      "id": "chapter1_11",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Rick Malloy, SJ, the university chaplain and former vice president of Mission and Ministry at the University of Scranton, puts the matter this way: “The moral praxis of our Jesuit institutions creates the context within which the practicality of the practice of moral norms and values by our students does, or does not, make sense. One concrete means to form the moral conscience of our students is clear: struggle to make Jesuit schools truly moral institutions.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-12",
      "id": "chapter1_12",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" The same can be said, of course, about all Catholic institutions. If we practice what we preach (and I believe our students are "), _c('i', [_vm._v("hearing")]), _vm._v(" about the values of the Gospel and Catholic social teaching on our campuses), our “students will be more likely to develop as moral persons.” If, on the other hand, we fail to model those values, “we will be subtly communicating to our students that it makes more sense to ‘Look out for Number One,’ ‘Grab All the Gusto You Can’ and forget the poor and oppressed of our world.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-13",
      "id": "chapter1_13",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" The commodification of higher education has created an environment increasingly dominated by both the “power and the ethic of the marketplace.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-14",
      "id": "chapter1_14",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" If we leave this trend unchecked, we implicitly tell our students that they are engaged in a market transaction, meant for their pleasure and prosperity. In this scenario, it makes good sense to cheat or to plagiarize, as those routes may be the most “efficient” road to “success.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-15",
      "id": "chapter1_15",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In his 2008 address at the Catholic University of America, Pope Benedict XVI stated that above all, Catholic universities must be a place where young people “encounter the living God who in Jesus Christ reveals his transforming love and truth (cf. "), _c('i', [_vm._v("Spe Salvi,")]), _vm._v(" no. 4).”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-16",
      "id": "chapter1_16",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" This encounter, he argued, must have both “informative” and “performative” dimensions. Fostering this encounter should entail more than just “communicating data.” The life of the campus community must manifest commitment to truth and love."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-17",
      "id": "chapter1_17",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" In other words, if we want our Christian students to grow in their faith and in their relationship with Jesus Christ and to become citizens responsible for the common good, we need to show them what the truth, beauty, and justice of the Catholic tradition looks like when incarnated."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-18",
      "id": "chapter1_18",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" They will not likely be attracted to the values of the Gospel if they do not see them in reality, or at least perceive that we are trying to embody them to the best of our ability. The individualistic, hedonistic, consumerist, promiscuous, and relativistic culture that characterizes much of college life today will remain embedded unless we show our students another way."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-19",
      "id": "chapter1_19",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" As Malloy argues, “students … deeply desire to free themselves and form "), _c('span', {
    attrs: {
      "aria-label": "14",
      "id": "pg_14",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("communities in light of Jesus’s call to serve and love others. They just aren’t being shown how.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-20",
      "id": "chapter1_20",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Malloy adds that every year 1,400 deaths and 70,000 sexual assaults and rapes happen as a result of drinking on college campuses. According to a White House Council on Women and Girls report, our nation’s campuses—where one in five women report being sexually assaulted—put women at risk more than in other environments in our society."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-21",
      "id": "chapter1_21",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Catholic institutions are generally no better than secular universities at eschewing the “beer and circus” culture that Murray Sperber described almost two decades ago."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-22",
      "id": "chapter1_22",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" Of course, many of our students admirably exemplify the love and discipleship of Christ in myriad ways, and I have had the privilege of meeting some of them. But there are many more (like me during my earliest student days) who fall into destructive patterns of behavior such as binge drinking or other addictions while struggling to discern their true nature and calling. To add to these problems, many students at our universities see college as a gateway to the world of high-class living. In deciding a course of study and a future career, making a commitment to the common good takes a back seat to individual success, very often conceived in terms of earning a salary in the highest income bracket. Giving in to the desires of the “I want it now” consumer, many colleges and universities create a country club atmosphere, replete with state-of-the-art fitness centers, stadiums, restaurants, and retail shops, rather than a place of learning."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-23",
      "id": "chapter1_23",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" As I will discuss throughout this book, Catholic institutions often fall prey to this trap, failing to challenge the status quo in this and in many other ways.")]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('samp', {
    staticClass: "SANS_Scala_Sans_Regular_11"
  }, [_vm._v("The Corporatized University and the Neoliberal Project")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("The corporatization of the modern university partly explains why Catholic universities fail to fully impress upon our students that the good life, the life God intends for us, entails loving one another and creating communities where the dignity and rights of all are respected. This point will become more obvious throughout this book. At this juncture, I want to describe the paradigm that informs many decisions at our Catholic colleges and universities today, a paradigm that conflicts with CST.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By corporatization of the university, I mean “an institution that is characterized by processes, decisional criteria, expectations, organizational "), _c('span', {
    attrs: {
      "aria-label": "15",
      "id": "pg_15",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("culture, and operating practices that are taken from, and have their origins in, the modern business corporation.” Corporatized universities are “characterized by the entry of the university into marketplace relationships and by the use of market strategies in university decision-making.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-24",
      "id": "chapter1_24",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" These strategies include, among others: responsibility-centered management (forcing individual colleges and departments to be fiscally independent); viewing students as customers and emphasizing “customer satisfaction”; heavy reliance on quantitative metrics to measure performance; hierarchical organizational structures; downsizing or elimination of departments (especially in the humanities) because they fail to generate revenue; the marketing and “branding” of the institution; the increasing number of managers and administrators; and accepting funds from corporations in exchange for influence over research and academic programming."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-25",
      "id": "chapter1_25",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" According to Marc Bousquet, the corporatized university engages in a bevy of business endeavors (from apparel sales and selecting vendors for books, food services, etc., to copywriting intellectual property) in order to enhance revenues and contain costs. In this way institutions of higher education are “commercialized: they’re inextricably implicated in profoundly capitalist objectives, however ‘nonprofit’ their missions.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-26",
      "id": "chapter1_26",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The corporatization of the university goes hand-in-hand with the commodification of higher education. Though not true of all students, many view higher education as simply another good to be purchased in the marketplace."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-27",
      "id": "chapter1_27",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" Faculty members are often seen as “cashiers” who should above all strive for the “consumer satisfaction” of their high-paying customers, i.e., students and their parents."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-28",
      "id": "chapter1_28",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Students and their parents now frequently choose majors based on potential earnings data."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-29",
      "id": "chapter1_29",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" A widespread perception exists that studying a field to follow a passion or to become an educated citizen—hallmarks of liberal education—is pass"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v(". Too many higher education leaders and professors have recoiled from teaching students ethics, civility, and that “good fortune confers a responsibility to live generously toward the less fortunate.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-30",
      "id": "chapter1_30",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Universities must brand and market themselves to compete for customers, driving a facilities “arms race” that uses noneducational amenities to lure students."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-31",
      "id": "chapter1_31",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Institutions commodify students “to the extent they become simply objects that keep the university afloat with cash,” as James Keenan states."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-32",
      "id": "chapter1_32",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" This capitalistic vision of education views education as an entitlement of those who can pay for it, and leaves students who cannot as fodder for the lending "), _c('span', {
    attrs: {
      "aria-label": "16",
      "id": "pg_16",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("industry."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-33",
      "id": "chapter1_33",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Some evidence suggests that university presidents and boards do not always use endowments to buoy essential academic programs or to provide more financial aid when possible. Instead they engage in “endowment hoarding” to maintain their own reputation as fundraisers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-34",
      "id": "chapter1_34",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" None of this is entirely new, as money and capitalistic values have always influenced US higher education. However, the “raw power” of money in shaping the entire landscape of higher education in recent decades is unprecedented."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-35",
      "id": "chapter1_35",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("A veteran of several different academic institutions, Bousquet has also described the “corporate welfare university.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-36",
      "id": "chapter1_36",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" He points to the various ways in which “corporate shareholders” benefit from high-priced higher education and the simultaneous “faculty proletarianization.” He maintains that the coffers of for-profit educational institutions have bloated over the last several decades, largely as a result of the ability to pay “casual faculty” low wages and no benefits (more on this in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 2")]), _vm._v(") while simultaneously charging exorbitant tuition and obtaining federal tax dollars. It is important to note that although nonprofit institutions of higher learning do not channel these savings to shareholders in the form of dividends, they do provide benefits to corporate beneficiaries. Among these are “shouldering the cost of job training, generation of patentable intellectual property, provision of sports spectacle, vending goods and services to student markets, and conversion of student aid into a cheap or even free labor pool.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-37",
      "id": "chapter1_37",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" David Kirp points out that academics and their institutions increasingly acquiesce to demands from “students, donors, corporations, politicians” to control the “priorities in higher education.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-38",
      "id": "chapter1_38",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Some critics argue that the business world wants education to be shaped in a way that produces workers who will serve their interests."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-39",
      "id": "chapter1_39",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In the last thirty years of “managed higher education,” the corporate class has also benefited from a growing number of well-paying managerial posts. Administrators have hired more administrators, increasingly from outside academe. They have simultaneously reduced the number of tenure-track faculty positions and decreased the pay of the majority of campus workers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-40",
      "id": "chapter1_40",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" The American Association of University Professors (AAUP) has noted that from 1976–2011 nonfaculty professional positions grew by 369 percent. Full-time executive positions increased by 141 percent. Tenure-track positions only grew by 23 percent, while part-time faculty swelled by 286 percent."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-41",
      "id": "chapter1_41",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" According to Bousquet, “the university "), _c('span', {
    attrs: {
      "aria-label": "17",
      "id": "pg_17",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("under managerial domination is an accumulation machine. If in nonprofits it accumulates in some form other than dividends, there’s all the more surplus for administrators, trustees, local politicians, and a handful of influential faculty to spend on a discretionary basis.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-42",
      "id": "chapter1_42",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Furthermore, university management wants to “remake competing campus cultures in its own image.”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Toward that end, university administrators have developed a deep sense of “solidarity” among themselves in opposition to faculty, according to Bousquet. They have been extraordinarily successful at eradicating “faculty culture” (e.g., academic freedom in teaching and research) and implanting “cultural materialism” in its place."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-43",
      "id": "chapter1_43",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Eliminating tenure-track posts and hiring more adjuncts (an issue discussed in more detail in the next chapter) and professional staff solidifies managerial control over university matters that were once in the domain of tenured faculty, in addition to providing a cost-cutting mechanism. In the corporatized university, the shared governance that promotes faculty and administrator collaboration in decision-making disappears in favor of top-down managerial control."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-44",
      "id": "chapter1_44",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This account does not intend to depict administrators as villains and faculty as paragons of virtue. As I shall discuss, many faculty members themselves have embraced the corporatization of the university. Moreover, some administrators understand the value of shared governance (fortunately I have worked with some of them). The AAUP rightly recognizes administrators and trustees who demonstrate outstanding commitment to shared governance. In fact, the board of trustees and the former president of Santa Clara University, Paul Locatelli, SJ, received the inaugural award in 1999."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-45",
      "id": "chapter1_45",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" However, the 2015 debacle at Mount St. Mary’s University in Maryland illustrates what can happen when the management style of the corporatized university runs amok. "), _c('i', [_vm._v("The Chronicle of Higher Education")]), _vm._v(" aptly called this fiasco a “corporate test case” that “failed miserably.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-46",
      "id": "chapter1_46",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" The university’s then-president fired two professors, and a provost was compelled to resign, for criticizing both the policies that hurt students and the president’s harsh rhetoric about struggling students.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The corporatization of the university reflects the larger neoliberal agenda to destroy solidarity among workers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-47",
      "id": "chapter1_47",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" The “neoliberal assault on universities” subjects faculty (and staff) to a constant barrage of “crises,” austerity measures, and so-called reforms in order to “soften the resistance "), _c('span', {
    attrs: {
      "aria-label": "18",
      "id": "pg_18",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("of faculty to change.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-48",
      "id": "chapter1_48",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Neoliberalism also promotes the retreat of the public sector in favor of the private sphere, which explains the major cuts in public funding of higher education even as tuition becomes prohibitive for many students."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-49",
      "id": "chapter1_49",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" In short, the seismic changes that have occurred over the last several decades at universities must be seen in a larger political and economic context—the ascendancy of neoliberalism.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("St. John Paul II aptly characterized neoliberalism in 1999:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "EXO"
  }, [_vm._v("More and more, in many countries of America, a system known as ‘neoliberalism’ prevails; based on a purely economic conception of man, this system considers profit and the law of the market as its only parameters, to the detriment of the dignity of and the respect due to individuals and peoples. At times this system has become the ideological justification for certain attitudes and behavior in the social and political spheres leading to the neglect of the weaker members of society. Indeed, the poor are becoming ever more numerous, victims of specific policies and structures which are often unjust."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-50",
      "id": "chapter1_50",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Neoliberalism, the dominant ideology of our time, entails economic policies such as privatization, deregulation, and tax cuts for the wealthy and corporations."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-51",
      "id": "chapter1_51",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" However, as Keri Day contends, it also represents a worldview and “cultural project” that seeks to “create a different community of persons” in which “persons are nothing more than material means toward the ends of another person’s goals.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-52",
      "id": "chapter1_52",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" Neoliberalism has ordained self-interest as the primary feature of human personhood and has fostered the human tendency to competition in all spheres of life."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-53",
      "id": "chapter1_53",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" It has attempted to eradicate “all forms of solidarity capable of challenging market-driven values.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-54",
      "id": "chapter1_54",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Given the pervasive influence of the ethos of neoliberalism on contemporary life, we should not be surprised that it has changed higher education for the worse (though many of us are unaware of this)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-55",
      "id": "chapter1_55",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Scholars have documented the explicit ways the business community and international institutions such as the IMF and World Bank have brought the neoliberal paradigm to the hallowed halls of our universities."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-56",
      "id": "chapter1_56",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" I will discuss this further in "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4")]), _vm._v(". For now, I want to stress that the corporatization of the modern university and the commodification of education both emanate from and promote larger, monumental shifts in values and practices found in advanced capitalist societies, quintessentially in the "), _c('span', {
    attrs: {
      "aria-label": "19",
      "id": "pg_19",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("United States."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-57",
      "id": "chapter1_57",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" Michael Sandel, one of the preeminent philosophers of our era, encapsulates this transformation as the movement from having a market economy to “being a market society.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-58",
      "id": "chapter1_58",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" As Sandel puts it, “the expansion of markets, and of market values, into spheres of life where they don’t belong … is one of the most significant developments of our time.” His book "), _c('i', [_vm._v("What Money Can Buy: The Moral Limits of Markets")]), _vm._v(" discusses myriad examples of how the market’s values and mechanisms have infiltrated just about every aspect of modern life. From the mundane ability of individuals to drive in carpool lanes for a fee, to absurdities like being paid to advertise on one’s forehead, to practices like wealthy couples paying women halfway around the world to carry surrogate pregnancies, Sandel laments that just about everything can be bought and sold. Among the consumer “products” that can be bought in our market society are seats at prestigious American universities (an issue I shall discuss in a subsequent chapter). Against the dominant modus operandi, Sandel rightly contends that the very nature of some goods, relationships, and values dictates that they not be demeaned by putting a price tag on them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-59",
      "id": "chapter1_59",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Those familiar with Catholic social teaching know that Sandel is in good company. A few decades ago Pope John Paul II called attention to an “idolatry of the market” that “ignores the existence of goods which by their nature are not and cannot be mere commodities.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-60",
      "id": "chapter1_60",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" The Pope also maintained that excessive focus on “false and superficial gratifications” through consumption and on maximizing profit has generated “alienation” in Western societies. Alienation takes place when the “value and grandeur of the human person,” along with her capacity for self-giving, is supplanted by the view that other persons are instruments of profit and/or self-gratification. John Paul argued that alienation occurs when human beings are used as a means rather than recognized as ends in themselves. In a capitalist society, this happens when human beings are treated like commodities. Succinctly stated, socialism produced alienation, but John Paul also recognized alienation in the dangerous tendency of market economies to commodify everything."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-61",
      "id": "chapter1_61",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" In more recent years Pope Benedict XVI and Pope Francis have repeated this concern."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-62",
      "id": "chapter1_62",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" The current pontiff forcefully stated:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "EXO"
  }, [_vm._v("The worship of the ancient golden calf (see Ex 32:1–35) has returned in a new and ruthless guise in the idolatry of money and the dictatorship "), _c('span', {
    attrs: {
      "aria-label": "20",
      "id": "pg_20",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("of an impersonal economy lacking a truly human purpose. The worldwide crisis affecting finance and the economy lays bare their imbalances and, above all, their lack of real concern for human beings; man is reduced to one of his needs alone: consumption."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-63",
      "id": "chapter1_63",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TXCON"
  }, [_vm._v("Succinctly stated, Catholic colleges and universities operate within the context of corporatized higher education and the larger neoliberal project, which challenges their ability to fulfill their mission. Let me now turn specifically to Catholic institutions of higher learning in the age of the corporatized university.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('samp', {
    staticClass: "SANS_Scala_Sans_Regular_11"
  }, [_vm._v("The Corporatized University and the Mission of Catholic Universities")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Like their US secular counterparts, Catholic universities vary in the degree to which they have succumbed to corporatization and the “market fundamentalism” critiqued by Sandel, the recent popes, and other thinkers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-64",
      "id": "chapter1_64",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Nonetheless, Catholic colleges and universities have certainly not remained immune to the corporatization of the university."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-65",
      "id": "chapter1_65",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" Renowned Catholic theologian David Hollenbach, SJ, questions whether or not US Catholic universities can remain faithful to their mission and identity today if they operate like corporations. He fears that the “pursuit of institutional advancement at the best Catholic universities can be a tool serving the self-interest and privilege of the powerful.” He cautions that seeking elite status by many Catholic universities has caused even their leaders to have “amnesia about their poor, immigrant roots.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-66",
      "id": "chapter1_66",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" Catholic universities are run by board members and increasingly by administrators with vast experience in the worlds of business, finance, and industry. However, like the majority of Roman Catholics, they often possess little more than a superficial understanding of Catholic social teaching."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-67",
      "id": "chapter1_67",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" The Association of Jesuit Colleges and Universities (AJCU) has explicitly acknowledged this leadership problem: “The majority of our lay people come without adequate formation or interest in learning about and implementing the mission beyond humanistic concerns, like ‘care of the person’ or a ‘commitment to service.’ In the absence of a ‘thick’ understanding of the tradition, these good and well-intentioned leaders will be uncertain about how to hire faculty and administrators who "), _c('span', {
    attrs: {
      "aria-label": "21",
      "id": "pg_21",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("explicitly engage the university’s mission and establish and promote programming that links directly to our Jesuit, Catholic identity.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-68",
      "id": "chapter1_68",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("William Byron, SJ, who served as president of three universities and on ten boards, commends lay leaders for bringing valuable skills from the business world. He concedes that board members should provide needed oversight on “brand building” and “product differentiation.” However, board members also need to be educated about the “Catholic identity of the institution.” They must remember that the “institution is grounded in the person and teachings of Jesus Christ” and that the “bottomline” cannot justify policies “that deplete in a qualitative way the institution’s human assets: its students, employees, and others.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-69",
      "id": "chapter1_69",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" Former Association of Catholic Colleges and Universities president Alice Gallin, OSU, also believes that the expertise and fundraising ability of lay trustees has been essential to the success of Catholic education. In her view, as lay people became trustees in the 1960s and 1970s, they wanted to preserve the “Catholic character” of their institutions. Nonetheless, she also contends that not enough was done to help them understand the mission of the institutions they served."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-70",
      "id": "chapter1_70",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The majority of board members at US colleges and universities hail from the business world or from professional services such as accounting, law, or medicine."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-71",
      "id": "chapter1_71",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" Although still a minority, university presidents also increasingly come from the corporate world. This makes some sense, given the growing need to fundraise because of waning state financial support."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-72",
      "id": "chapter1_72",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" In my judgment, however, if board members, administrators, and faculty members with power are primarily trained in US business schools or economics departments, there is reason to believe that they may not embrace the social anthropology that undergirds CST."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-73",
      "id": "chapter1_73",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" CST sees the human person as a member of an interdependent family; the person’s nature and destiny is fulfilled in solidarity with others and through sustained commitment to the common good (see the section of this chapter below on the principles and themes of CST)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-74",
      "id": "chapter1_74",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" On the contrary, US business education has largely abandoned its original commitments to “service and calling” in favor of “neoliberal utopianism” that prizes self-interest and profit maximization, according to Rakesh Khurana of Harvard Business School."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-75",
      "id": "chapter1_75",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" Both modern economics and the curricula of US business schools tend to emphasize a contrasting understanding of the human person as "), _c('i', [_vm._v("homo economicus")]), _vm._v(". This reductionistic anthropology holds that humans always act "), _c('span', {
    attrs: {
      "aria-label": "22",
      "id": "pg_22",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“rationally,” construed as acting in order to maximize self-interest."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-76",
      "id": "chapter1_76",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" “This economic man ("), _c('i', [_vm._v("homo economicus")]), _vm._v(") is utterly self-serving and only interested in maximizing his immediate utility. Economic man is therefore only engaging in transactional, short-term oriented encounters with others.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-77",
      "id": "chapter1_77",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" This view of the human person undergirds neoliberalism and informs much of current management theory and practice."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-78",
      "id": "chapter1_78",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" The anthropology of "), _c('i', [_vm._v("homo economicus")]), _vm._v(" leads to a leadership and organizational culture that is adversarial, competitive, “efficiency oriented” and “centered on hierarchies and top-down decision-making.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-79",
      "id": "chapter1_79",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" In this regard, Keenan and others have argued that universities resemble “fiefdoms,” in which “administrators function like feudal lords.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-80",
      "id": "chapter1_80",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Research demonstrates that students who are predominantly exposed to this individualistic anthropology in economics and business courses tend to behave as self-interest maximizers and see human beings as fundamentally in competition with one another."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-81",
      "id": "chapter1_81",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" Michael Pirson of Fordham University’s Graduate School of Business has therefore argued for eschewing the “economism paradigm” of business education, leadership, management theory, and corporate governance structures in favor of a “humanistic paradigm.” The latter adopts an anthropology based on a “renewed Darwinian theory” in the light of contemporary neuroscience and behavioral economics, while evolutionary psychology posits that human beings are not simply self-interest maximizers. Rather, humans have four basic drives: to acquire, to bond, to comprehend, and to defend. According to the humanistic paradigm, human beings are “intrinsically motivated to self-actualize and serve humanity through what they do.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-82",
      "id": "chapter1_82",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" As Pirson and Lawrence point out, this understanding of the human person has much in common with Aristotle’s notion of "), _c('i', [_vm._v("zōon politikon")]), _vm._v(", which sees human beings as social by nature (like Catholic social teaching). This humanistic model must displace "), _c('i', [_vm._v("homo economicus")]), _vm._v(" in order to prevent financial crises like that of 2008 from happening again and to promote “the sustainable development of business in the future.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-83",
      "id": "chapter1_83",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("To be clear, faculty members in all fields, not just business or economics, bear responsibility for the persistence of flawed understandings of the human person, community, and the mission of Catholic universities. As Gallin maintains, at a certain point in the history of Catholic higher education, lay and religious faculty alike began to prioritize “academic excellence” and “competitive achievement in the various disciplines of "), _c('span', {
    attrs: {
      "aria-label": "23",
      "id": "pg_23",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("study” over “character formation and moral development of young people.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-84",
      "id": "chapter1_84",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" As employees in the corporatized university and denizens of the larger neoliberal world order, many faculty have consciously or subconsciously embraced "), _c('i', [_vm._v("homo economicus")]), _vm._v(". Many academics have put their heads in the sand while “neoliberalism’s war on higher education” has been occurring."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-85",
      "id": "chapter1_85",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" With some exceptions, they have often remained in their silos churning out work in their disciplines rather than striving against corporatization and for the common good. As Keenan maintains, this problem predates the corporatization of the university. The long and lonely process of writing a dissertation initiates academics into the “isolationist culture” of the academy, which rewards individual toil and achievement much more than teamwork and contribution to the community."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-86",
      "id": "chapter1_86",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" However, corporatization has exacerbated the problem. Faculty members have largely “adapted to the conditions of our profession by developing a culture as steeped in the ethos of productivity and salesmanship as one might encounter in the business world"), _c('i', [_vm._v(".")]), _vm._v("”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-87",
      "id": "chapter1_87",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" Anyone who has ever attended an academic conference will recognize the truth in this statement!")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Even worse, some academics function as “gated intellectuals,” who legitimize the neoliberal global order by giving it intellectual “cover,” as Giroux states. These shills eschew any responsibility for the hordes of marginalized people afflicted by neoliberalism."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-88",
      "id": "chapter1_88",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" This includes, as I will discuss in the following chapters, ignoring the plight of colleagues who work as contingent faculty members and students who struggle to afford their education. Some academics reject the status quo of corporatized higher education and its deleterious consequences, but many acquiesce due to fear and/or fatigue. Research indicates that the extreme emphasis on productivity at the corporatized university has led many academics to feel overworked, stressed out, and hopeless."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-89",
      "id": "chapter1_89",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("To summarize, if decision-makers at Catholic colleges and universities hold a view of the human person that is antithetical to the anthropology of the Catholic tradition, they may make governance decisions that are at odds with CST. A distorted understanding of human nature that depicts human beings as fundamentally in competition with one another and not capable of making compromises for the good of the community will not lead to a management style and policy decisions rooted in CST."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-90",
      "id": "chapter1_90",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" This does not mean that all university leaders consciously embrace "), _c('i', [_vm._v("homo economicus")]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "24",
      "id": "pg_24",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("and have conspired to advance the neoliberal agenda described here. In addition, Catholic colleges and universities certainly sometimes adopt practices and policies that contradict the spirit of "), _c('i', [_vm._v("homo economicus")]), _vm._v(", as the positive examples in this book will demonstrate. There are numerous forces at work on Catholic campuses, many of them good. Nonetheless, well-intended board members, administrators and faculty members may import or tacitly accept corporate models of financial and personnel management into Catholic higher education, while not seriously contemplating how solidarity, justice, human rights, the common good, and the option for the poor should shape the university’s internal policies and structures. As I have seen firsthand, those university leaders who conscientiously introduce concepts from CST into conversations about university operations may meet strong resistance."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-91",
      "id": "chapter1_91",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Catholic social teaching, however, insists that these ideals serve as guiding principles for our institutions. Saint John Paul II’s Apostolic Constitution on Higher Education "), _c('i', [_vm._v("Ex Corde Ecclesiae")]), _vm._v(" makes this clear:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "EXO"
  }, [_vm._v("A Catholic University pursues its objectives through its "), _c('i', [_vm._v("formation of an authentic human community animated by the spirit of Christ")]), _vm._v(". The source of its unity springs from a common dedication to the truth, a common vision of the dignity of the human person and, ultimately, the person and message of Christ which gives the Institution its distinctive character. As a result of this inspiration, the community is animated by a spirit of freedom and charity; it is characterized by "), _c('i', [_vm._v("mutual respect, sincere dialogue, and protection of the rights of individuals")]), _vm._v(". It assists each of its members to achieve wholeness as human persons; in turn, everyone in the community helps in promoting unity, and each one, according to his or her role and capacity, contributes towards decisions which affect the community, and also towards maintaining and strengthening the distinctive Catholic character of the Institution."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-92",
      "id": "chapter1_92",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("CST enumerates a substantial list of human rights that the university community should protect, such as the right to a just wage, freedom of association, education, affordable health care, rest (at least one day per week and a yearly vacation), retirement pensions, unemployment insurance, workers compensation, parental leave, and participation in decision-making."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-93",
      "id": "chapter1_93",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" The affirmation of these rights has obvious policy implications "), _c('span', {
    attrs: {
      "aria-label": "25",
      "id": "pg_25",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("for Catholic universities, as this book will demonstrate. In fact, canon law mandates that church institutions embody CST in their policies, reflected in requirements to pay just wages and to recognize employees’ right to unionize."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-94",
      "id": "chapter1_94",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" As the United States Conference of Catholic Bishops’ document "), _c('i', [_vm._v("Economic Justice for All")]), _vm._v(" states:")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "EXO"
  }, [_vm._v("All the moral principles that govern the just operation of any economic endeavor apply to the Church and its agencies and institutions; indeed the Church should be exemplary. The Synod of Bishops in 1971 worded this challenge most aptly: “While the Church is bound to give witness to justice, she recognizes that anyone who ventures to speak to people about justice must first be just in their eyes. Hence, we must undertake an examination of the modes of acting and of the possessions and lifestyle found within the Church herself.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-95",
      "id": "chapter1_95",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TXCON"
  }, [_c('i', [_vm._v("Ex Corde Ecclesiae")]), _vm._v(" brings into further relief the conflict between the ideals that should govern Catholic universities and the capitalistic values of the corporatized university. Successive chapters in this book will elucidate the nature of this conflict in greater detail. For now, I aim to establish that Catholic teaching dictates that Catholic universities cannot ignore CST in their institutional policies and commitment. In order to dispel any doubt on the matter, let me list what "), _c('i', [_vm._v("Ex Corde")]), _vm._v(" considers “"), _c('i', [_vm._v("essential characteristics")]), _vm._v("” that “every Catholic University, as "), _c('i', [_vm._v("Catholic")]), _vm._v("” should display:")]), _vm._v(" "), _c('ol', {
    staticClass: "num"
  }, [_c('li', {
    staticClass: "NLF"
  }, [_vm._v("a Christian inspiration not only of individuals but of the university community as such;")]), _vm._v(" "), _c('li', {
    staticClass: "NL"
  }, [_vm._v("a continuing reflection in the light of the Catholic faith upon the growing treasury of human knowledge, to which it seeks to contribute by its own research;")]), _vm._v(" "), _c('li', {
    staticClass: "NL"
  }, [_vm._v("fidelity to the Christian message as it comes to us through the church;")]), _vm._v(" "), _c('li', {
    staticClass: "NLL"
  }, [_vm._v("an institutional commitment to the service of the people of God and of the human family in their pilgrimage to the transcendent goal which gives meaning to life."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-96",
      "id": "chapter1_96",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Furthermore, CST holds that education, like other public goods, cannot and should not be commodified. To assume that the market alone can assure all human goods is tantamount to “idolatry of the market,” according "), _c('span', {
    attrs: {
      "aria-label": "26",
      "id": "pg_26",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("to John Paul II."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-97",
      "id": "chapter1_97",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])]), _vm._v(" Like health care and other goods, CST maintains that education is a human right owed to all people, not something to be sold like cigarettes or candy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-98",
      "id": "chapter1_98",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" Thus, the logic of the market should not dominate Catholic higher education."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-99",
      "id": "chapter1_99",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" If we demonstrate by our policy decisions and institutional arrangements that our values can be forsaken in the name of “efficiency,” “fiscal responsibility,” “innovation,” “market competition,” etc., we convey to our students that living out the Gospel and Catholic social teaching costs too much, thereby affirming the nihilism and relativism already in the air."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-100",
      "id": "chapter1_100",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])]), _vm._v(" In the words of the late Fr. Dean Brackley, nurturing the faith of our students requires “orthopraxis, including conspicuous respect for the rights of workers and all vulnerable members of the learning community.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-101",
      "id": "chapter1_101",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" In short, Catholic universities must both expose their students to Catholic social teaching across the curriculum (not only in theology classes), advance justice and solidarity in the world, and embody CST "), _c('i', [_vm._v("intramurally")]), _vm._v(" in order to fulfill their role in the church’s mission of evangelization."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-102",
      "id": "chapter1_102",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" I argue in this book that the latter of these areas has been the most neglected.")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('samp', {
    staticClass: "SANS_Scala_Sans_Regular_11"
  }, [_vm._v("Expanding the Conversation about Mission and Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_c('i', [_vm._v("Ex Corde Ecclesiae")]), _vm._v(" discusses evangelization as an important element of the mission of Catholic universities. It defines evangelization as “bringing the Good News into all the strata of humanity, and through its influence transforming humanity from within and making it new.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-103",
      "id": "chapter1_103",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" John Paul II argues that in addition to communicating the truth of the Gospel, universities must evangelize by “upsetting, through the power of the Gospel, humanity’s criteria of judgment, determining values, points of interest, lines of thought, sources of inspiration and models of life, which are in contrast with the Word of God and the plan of salvation.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-104",
      "id": "chapter1_104",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" The university’s task in evangelization is thus to be “a living "), _c('i', [_vm._v("institutional")]), _vm._v(" witness to Christ and his message, so vitally important in cultures marked by secularism, or where Christ and his message are still virtually unknown.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-105",
      "id": "chapter1_105",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" In his apostolic exhortation "), _c('i', [_vm._v("Evangelii Gaudium")]), _vm._v(", Pope Francis has recalled this dimension of the mission of Catholic universities, which are “outstanding environments for articulating and developing this evangelizing commitment in an interdisciplinary and integrated way.” According to Francis, Catholic universities must serve as a “valuable resource for the evangelization of "), _c('span', {
    attrs: {
      "aria-label": "27",
      "id": "pg_27",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("culture” and search for appropriate ways of undertaking this endeavor in situations where cultural currents and dominant trends oppose the values of the Gospel."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-106",
      "id": "chapter1_106",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" Thus, an essential element of the mission of every Catholic university requires challenging the dominant paradigm of the corporatized university in order to render the Gospel credible in a pervasive, institutionalized culture that rejects it. In order to achieve this goal, the university must demonstrate the possibility of creating structures and policies imbued with the values and principles of CST. “Today more than ever, the Church is aware that her social message will gain credibility more immediately from the "), _c('i', [_vm._v("witness of actions")]), _vm._v(" than as a result of its internal logic and consistency,” as John Paul II put it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-107",
      "id": "chapter1_107",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])]), _vm._v(" More than two thousand years earlier, Jesus of Nazareth thus admonished his disciples, “You will know them by their fruits. Are grapes gathered from thorns, or figs from thistles? In the same way, every good tree bears good fruit, but the bad tree bears bad fruit” (Matt 7:16–18)."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-108",
      "id": "chapter1_108",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" Succinctly stated, Catholic universities must build solidarity with the oppressed and promote “justice and liberation from every kind of oppression,” both beyond and on their campuses, in order to evangelize."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-109",
      "id": "chapter1_109",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In recent decades, a spate of books has considered how Catholic universities should fulfill their mission and sustain their ecclesial identity in the contemporary pluralistic American context."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-110",
      "id": "chapter1_110",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])]), _vm._v(" These books tend to focus on how the university should transmit the content of the Catholic faith through theology courses, Catholic studies programs, and in the broader curriculum. Some discuss issues of academic freedom, hiring for mission, and the place of the Catholic university in the broader academy. Fewer deal with the universities’ responsibility to promote justice, solidarity, and the option for the poor in more than a passing way."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-111",
      "id": "chapter1_111",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" There are some noteworthy exceptions. David O’Brien’s book "), _c('i', [_vm._v("From the Heart of the American Church: Catholic Higher Education in American Culture")]), _vm._v(", which was published in 1994, argued that “the goal of Catholic education” should be the formation of students dedicated to justice and peace. O’Brien maintained that “education for justice and peace” cannot occur without scholars committed to it. Yet, he contended at the time that “the notion of intellectual life lived in terms of justice remains controversial and threatening to many in the academy and in the church.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-112",
      "id": "chapter1_112",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])]), _vm._v(" More recently Thomas Rausch’s "), _c('i', [_vm._v("Educating for Faith and Justice: Catholic Higher Education Today")]), _vm._v(" and Suzanne Toton’s "), _c('i', [_vm._v("Justice Education: From Service to Solidarity")]), _vm._v(" rank among "), _c('span', {
    attrs: {
      "aria-label": "28",
      "id": "pg_28",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("the best articulations of the theological and ethical foundations for every Catholic university’s Gospel-based mandate to act for justice in the world."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-113",
      "id": "chapter1_113",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" Readers looking for a robust theological justification for a Catholic university’s responsibility to promote justice should engage these works. Both Rausch and Toton find inspiration and the theoretical bases for this aspect of mission from the prophetic musings and living witness to the Gospel of the Jesuit martyrs of the UCA (Universidad Centroamericana Jos"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v(" Sime"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ó")]), _vm._v("n Ca"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ñ")]), _vm._v("as). They especially value Ignacio Ellacur"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("í")]), _vm._v("a and other important figures such as Oscar Romero and Pedro Arrupe."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-114",
      "id": "chapter1_114",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])]), _vm._v(" In moving to concrete means of fulfilling this role, Rausch and his fellow contributors see community-based learning, service immersion trips, and other educational programs as fruitful means of cultivating solidarity with the poor and the marginalized."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-115",
      "id": "chapter1_115",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" Toton (my former colleague at Villanova University) moves beyond curricular endeavors to concrete examples of action for justice in broader society. Having taught service learning courses for ten years myself, I concur with her that such experiential learning encounters with the poor only represent important “first steps” toward the solidarity with the poor called for by the university’s mission."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-116",
      "id": "chapter1_116",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])]), _vm._v(" I have witnessed numerous students undergo the beginnings of a "), _c('i', [_vm._v("metanoia")]), _vm._v(", or conversion of the heart, which can be the wellspring of solidarity. Research attests to this transformative dimension of service-learning."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-117",
      "id": "chapter1_117",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" Yet, solidarity as understood in CST must move beyond awareness and crisis intervention to contemplating the causes of the suffering of the marginalized and oppressed and to acting with them in order to promote structural and systemic change."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-118",
      "id": "chapter1_118",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" Toton rightly warns that Catholic universities can be lulled into thinking they have fulfilled their mandate to promote justice in the world by maintaining strong service-learning programs, which at best help succor the needs of the poor but do little to bend the broken world toward the Reign of God by dismantling unjust social structures. In my judgment, university officials eagerly tout the plethora of students engaged in service activities in soup kitchens, underfunded schools, hospices, and other community organizations as evidence of fulfillment of the mandate to work for justice and the common good. However, service learning, while meaningful and well-intentioned, “cannot substitute for the kind of action required to affect structural and systemic change,” and it can distract from “the time-consuming organizing, strategizing, mobilizing, confronting, reconstituting and negotiating that is part and parcel of action for justice.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-119",
      "id": "chapter1_119",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "29",
      "id": "pg_29",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("The gospel call to “action on behalf of justice” (a phrase from the 1971 Synod of Bishops’ document "), _c('i', [_vm._v("Justice in the World")]), _vm._v(") and creating solidarity with the poor requires greater risk-taking by the university in order to help transform the world, as Toton contends."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-120",
      "id": "chapter1_120",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The recent volume "), _c('i', [_vm._v("A Vision of Justice: Engaging Catholic Social Teaching on the College Campus")]), _vm._v(" focuses on theoretical discussions of CST and its concepts but also provides some inspiring examples of students, faculty, and staff at Catholic universities going beyond charity to do the work of justice, engaging in solidarity with marginalized immigrants, the poor, victims of human trafficking, and promoting sustainability and care of God’s creation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-121",
      "id": "chapter1_121",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121")])]), _vm._v(" Undoubtedly, many more members of Catholic campuses put CST in action in their local and distant communities. However, the encouraging stories in "), _c('i', [_vm._v("A Vision of Justice")]), _vm._v(" and those akin to them most often involve doing justice "), _c('i', [_vm._v("ad extra")]), _vm._v(", or beyond the walls of the university. Such efforts to transform broader society constitute important elements of a Catholic university’s mission."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-122",
      "id": "chapter1_122",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("122")])]), _vm._v(" However, doing justice in the world does not exonerate Catholic institutions from promoting justice and human rights within their walls. I therefore argue that Catholic universities must also risk being prophetic by showing the academic industry in the United States that there is a more humane and just way of maintaining institutions of higher learning. As John Paul II stated, “If need be, a Catholic university must have the courage to speak uncomfortable truths which do not please public opinion, but which are necessary to safeguard the authentic good of society.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-123",
      "id": "chapter1_123",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("123")])]), _vm._v(" They must also critically interrogate the individualistic conception of the human person so dominant in the American psyche in order to a promote a “true Christian anthropology, founded on the person of Christ, which will bring the dynamism of the creation and redemption to bear on reality and on the correct solution to the problems of life.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-124",
      "id": "chapter1_124",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("124")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In the American context, where many demonize the poor and blame them for their plight, this task requires universities to adopt the option for the poor, one of CST’s bedrock principles, in their institutional practices."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-125",
      "id": "chapter1_125",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("125")])]), _vm._v(" Catholic leaders such as the former superior general of the Jesuits Peter-Hans Kolvenbach, SJ, have urged creating institutions of higher education that keep principles such as the option for the poor at the forefront of their research, teaching, and admissions policies."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-126",
      "id": "chapter1_126",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("126")])]), _vm._v(" The Association of Catholic Colleges and Universities has also issued a vision statement "), _c('span', {
    attrs: {
      "aria-label": "30",
      "id": "pg_30",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("that calls upon Catholic institutions to “continue to strive to incorporate CST into all aspects of their institutional life.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-127",
      "id": "chapter1_127",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("127")])]), _vm._v(" Trustees, administrators, faculty, staff, and students are thus tasked with finding another way, of being a “sign of contradiction” (see Lk. 2:34; Acts 28:22) in the corporatized higher education industry."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-128",
      "id": "chapter1_128",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("128")])]), _vm._v(" Academics in the areas of finance, management, economics, and other fields can and should use their expertise to discern how to make Catholic institutions better conform to the norms of CST while remaining financially viable.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In order for this to occur, faculty, administrators, board members, and students must gain a deeper appreciation for the Catholic institution’s mission and for Catholic social teaching. Attaining this outcome can only be the product of sustained formation and community-building, not perfunctory nods in the direction of mission."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-129",
      "id": "chapter1_129",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("129")])]), _vm._v(" We need what Parker Palmer calls “transformative conversations on campus” to occur more regularly."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-130",
      "id": "chapter1_130",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("130")])]), _vm._v(" This requires all members of the university community to exit their silos. The corporatized university and neoliberal ethos militate against this by pitting us against one another and creating “time poverty.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-131",
      "id": "chapter1_131",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("131")])]), _vm._v(" As bell hooks laments, educational communities in the US have lost the “feeling of community.” Nonetheless, we must therefore confront our “feelings of loss and restore our sense of connection” if we are to change the status quo and pursue our mission more earnestly."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-132",
      "id": "chapter1_132",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("132")])]), _vm._v(" I would add that the rank and tenure standards for professors should valorize commitment to this work, rather than paying lip service to it and lionizing “star” researchers much more heavily."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-133",
      "id": "chapter1_133",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("133")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Some promising work is already being done in this vein at Catholic institutions. For example, Regis University instituted a three-year program that introduces new faculty, administrators, and professional staff to the “spiritual and intellectual ethos” of the university."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-134",
      "id": "chapter1_134",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("134")])]), _vm._v(" The length of this program implies that it has a better chance of achieving its goals than the often-encountered cursory orientation to mission. The program’s guiding document “Traditions” contains a robust discussion of what it means to be a Catholic, Jesuit university. Most notable for this analysis is the document’s mention of “institutional practices faithful to the Christian message,” the formation of “authentic human community” on campus, and “maintaining the highest ethical relationships within the Regis community as well as with partners, suppliers and other business entities, the Catholic Church, other religious traditions and educational institutions.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-135",
      "id": "chapter1_135",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("135")])]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "31",
      "id": "pg_31",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Given Byron and Gallin’s concerns cited above regarding boards, colleges should provide a similar program for board members. As Bishop Robert McElroy stated at a conference for trustees held at the University of San Francisco, the duty to advance the mission of a Catholic institution belongs to all board members, not just full-time employees."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-136",
      "id": "chapter1_136",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("136")])]), _vm._v(" At Villanova University, Dr. Barbara Wall implemented a rich seminar on Catholic social teaching for faculty and staff."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-137",
      "id": "chapter1_137",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("137")])]), _vm._v(" Administrators and board members could also benefit from this type of seminar given their shared responsibility for mission. Furthermore, mandatory units in courses across the curriculum could ensure that all students gain a better grasp of Catholic social teaching in order to understand how their institutions should embody CST and reject the “playground of unregulated freedom” style of much US higher education."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-138",
      "id": "chapter1_138",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("138")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The subsequent chapters in this book consider concrete ways to shape various aspects of the life of the Catholic university “within its own walls” in accordance with CST, which as John Paul II and the USCCB maintained, spells out the demands of the Gospel with greater specificity."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-139",
      "id": "chapter1_139",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("139")])]), _vm._v(" Catholic social teaching permits moving from more general biblical values and norms to actions, policies, and institutional priorities. A brief examination of CST will clarify this issue and articulate the normative framework used throughout the rest of the book.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('samp', {
    staticClass: "SANS_Scala_Sans_Regular_11"
  }, [_vm._v("A Brief Overview of Catholic Social Teaching")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Catholic scholars have produced a number of excellent summaries and commentaries on Catholic social teaching over the last few decades."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-140",
      "id": "chapter1_140",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("140")])]), _vm._v(" Those who wish to take the institutional mission of the Catholic university seriously ought to study these kinds of works. For those readers unfamiliar with the values and principles of CST, I can only provide here a broad-brush overview of them. Subsequent chapters will expand on these concepts as they relate to the issues at hand.")]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h3', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("The Dignity of the Human Person")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("This idea, rooted in the Genesis creation story, tells us that the image of God ("), _c('i', [_vm._v("imago Dei")]), _vm._v(") exists in all persons (Gen. 1:27), which connotes the equal dignity of all members of the human family."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-141",
      "id": "chapter1_141",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("141")])]), _vm._v(" Vatican II’s "), _c('i', [_vm._v("Gaudium et Spes")]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "32",
      "id": "pg_32",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("argues that the incarnation of Jesus Christ restored the fullness of human dignity, which was marred by original sin."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-142",
      "id": "chapter1_142",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("142")])]), _vm._v(" Thus, Christ enables human beings to participate in his salvific activity in the world and the building of the kingdom of God by embodying solidarity.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Many people both within and beyond Christian churches posit human dignity as the philosophical foundation of human rights."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-143",
      "id": "chapter1_143",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("143")])]), _vm._v(" As Catholic legal scholar Mary Ann Glendon observes, human dignity is the ultimate value enshrined in the UN Universal Declaration of Human Rights."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-144",
      "id": "chapter1_144",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("144")])]), _vm._v(" The Catholic tradition holds that the social ministry of the church exists to safeguard human dignity. According to David Hollenbach, “Human dignity is not an abstract or ethereal reality but is realized in concrete conditions of personal, social, economic and political life. The history of papal teaching has been a process of discovering and identifying these conditions of humanity. These conditions are called human rights.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-145",
      "id": "chapter1_145",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("145")])]), _vm._v(" In other words, the charge to protect human dignity requires promoting human rights in all areas of human life. For example, CST holds that the dignity of the worker demands that she or he “cannot be treated simply as a commodity” and has certain inalienable rights."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-146",
      "id": "chapter1_146",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("146")])]), _vm._v(" Recent papal social teaching emphasizes not only the unique dignity of the human person, but the dignity of all God’s creation as well. Human beings therefore have the duty to respect and to safeguard all living creatures and the natural environment."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-147",
      "id": "chapter1_147",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("147")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h3', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Human Rights and Duties")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Catholicism has long endorsed human rights, which are indispensable for protecting human dignity."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-148",
      "id": "chapter1_148",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("148")])]), _vm._v(" The church, which is made up of imperfect human beings, has at times failed to protect the human rights of all."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-149",
      "id": "chapter1_149",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("149")])]), _vm._v(" However, observers such as noted political scientist Samuel Huntingdon have regarded the Catholic Church as one of the primary defenders of human rights in the twentieth century."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-150",
      "id": "chapter1_150",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("150")])]), _vm._v(" Catholic teaching first embraced so-called social and economic rights, while later coming to acknowledge political and civil rights."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-151",
      "id": "chapter1_151",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("151")])]), _vm._v(" Saint John XXIII’s encyclical "), _c('i', [_vm._v("Pacem in Terris")]), _vm._v(", often deemed Catholicism’s Magna Carta, represents the most systematic and extensive presentation of rights and duties in the Catholic social tradition. It contains the first listing of the full panoply of rights endorsed by Catholicism. David Hollenbach has usefully categorized the rights affirmed in "), _c('i', [_vm._v("Pacem in Terris")]), _vm._v(" as “bodily rights, political rights, rights of movement, "), _c('span', {
    attrs: {
      "aria-label": "33",
      "id": "pg_33",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("associational rights, economic rights, sexual and familial rights, religious rights and communication rights.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-152",
      "id": "chapter1_152",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("152")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The fulfillment of human rights is the linchpin of peace."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-153",
      "id": "chapter1_153",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("153")])]), _vm._v(" Catholicism also holds that human rights demarcate “the minimum conditions for life in the community.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-154",
      "id": "chapter1_154",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("154")])]), _vm._v(" Human dignity is threatened when people cannot participate in society as a result of debilitating social, political, and economic conditions. In other words, the chief responsibility of a society is to ensure that individual rights are respected and “coordinated with other rights” so that each individual can fulfill her or his duties in society and promote the common good."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-155",
      "id": "chapter1_155",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("155")])]), _vm._v(" According to Catholic teaching, both rights and duties are dictates of natural law, which means they arise from the very nature of the human person. As John XXIII put it, “rights as well as duties find their inviolability in the natural law which grants or enjoins them.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-156",
      "id": "chapter1_156",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("156")])]), _vm._v(" Appealing to Romans 2:15, he contends that God has “has stamped man’s ["), _c('i', [_vm._v("sic")]), _vm._v("] inmost being with an order revealed to man ["), _c('i', [_vm._v("sic")]), _vm._v("] by his conscience; and his conscience insists on preserving it.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-157",
      "id": "chapter1_157",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("157")])]), _vm._v(" The order found in the universe is embedded in human personhood and forms the basis of the human person’s inviolable dignity. Thus, human nature itself, imbued with dignity by the Creator, is the basis of all human rights."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-158",
      "id": "chapter1_158",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("158")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Catholic social teaching also grounds human rights in the theology of the Christian tradition. Jesus Christ is ultimately the foundation and source of all rights."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-159",
      "id": "chapter1_159",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("159")])]), _vm._v(" God unites God’s very self to every human person through the incarnation of Jesus Christ. The doctrine of the incarnation holds that God became human in Jesus Christ and remains present in all humanity. Although human dignity was tarnished by original sin, Jesus Christ fully restored it by becoming one of us. Catholic teaching insists on respecting this sacred dignity, which requires safeguarding human rights."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-160",
      "id": "chapter1_160",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("160")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h3', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("The Social Nature of the Human Person")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Catholic theologians Michael and Kenneth Himes acknowledge the Catholic natural law perspective on human nature and human rights, but they also stress that the Trinitarian nature of God reveals to us what it means to be human and provides a robust theological foundation for human rights. To love and to be loved is the essence of being human."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-161",
      "id": "chapter1_161",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("161")])]), _vm._v(" Unlike philosophical liberalism, social contract theory, rational choice theory, and similar approaches, Catholicism posits that the human person is inherently social. "), _c('span', {
    attrs: {
      "aria-label": "34",
      "id": "pg_34",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Human beings are naturally members of multiple communities (family, civic, religious, national, racial, ethnic, the human community, etc.). This social anthropology of Catholicism undergirds the contention that all human beings are obligated to recognize the dignity of others and to work together for the common good."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-162",
      "id": "chapter1_162",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("162")])]), _vm._v(" Although a communitarian spirit has existed in certain eras of US history and imbues some segments of society today, radical or excessive individualism pervades our contemporary culture and political discourse."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-163",
      "id": "chapter1_163",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("163")])]), _vm._v(" The social understanding of the person in CST challenges radical individualism. Margaret Thatcher famously said that “there is no such thing as society,” only individuals. Catholicism flatly rejects this claim. Catholicism requires that we mirror the loving relationships of mutuality present in the Trinity in our interpersonal relationships and that we construct societies that do so as well."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-164",
      "id": "chapter1_164",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("164")])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h3', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("The Common Good and the Public Order")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("The notion of the common good and public order is also derived from the social nature of human beings."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-165",
      "id": "chapter1_165",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("165")])]), _vm._v(" CST defines the common good as the “sum total” of material, spiritual, political, and cultural conditions that make it possible for women and men to fully flourish as human beings. The common good is not analogous to a pie to be divided up; rather it is indivisible and remains common. Thus understood, pursuit of the common good is an essential task of societies and the global human family."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-166",
      "id": "chapter1_166",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("166")])]), _vm._v(" "), _c('i', [_vm._v("Gaudium et Spes")]), _vm._v(" states: “Every social group must take account of the needs and legitimate aspirations of other groups, and even of the general welfare of the entire human family.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-167",
      "id": "chapter1_167",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("167")])]), _vm._v(" In other words, all human beings have a right to share in the common good and a duty to foster it. As Hollenbach contends, fostering the common good requires more than tolerance toward one’s neighbors and fellow citizens; it requires active solidarity with them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-168",
      "id": "chapter1_168",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("168")])]), _vm._v(" More privileged members of the community may need to relinquish some of their privileges for the sake of the common good."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-169",
      "id": "chapter1_169",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("169")])]), _vm._v(" Yet, unlike libertarianism and extreme forms of communitarianism (such as communism), CST seeks to preserve both the rights of individuals and the common good, seeking a balance between the two. Furthermore, like the Pauline notion of the Body of Christ (see I Cor. 12:12–26; Eph. 4), CST holds that the well-being of the individual depends on the welfare of the entire human community; the suffering or deprivation of one member diminishes the good "), _c('span', {
    attrs: {
      "aria-label": "35",
      "id": "pg_35",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("of all."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-170",
      "id": "chapter1_170",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("170")])]), _vm._v(" This conception of the common good directly contrasts with the “sink-or-swim” outlook of neoliberal capitalism and the “NIMBY” (“not in my back yard”) mentality in American society. This idea also starkly departs from the vision of the “good life” that many Americans hold, which cherishes individualistic success and prosperity above all.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("All members of society must contribute to the common good in accordance with their own gifts and abilities. All organizations, including local authorities and the state, hold responsibility for the common good."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-171",
      "id": "chapter1_171",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("171")])]), _vm._v(" John Courtney Murray, SJ, argued that the whole of society is responsible for the common good, while the state always maintains direct responsibility for that part of the common good called the public order."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-172",
      "id": "chapter1_172",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("172")])]), _vm._v(" According to Vatican II’s "), _c('i', [_vm._v("Declaration on Religious Freedom")]), _vm._v(", in order for the state to maintain the public order, it must provide for: (1) the protection of the rights due to all citizens in accordance with justice; (2) “public peace”; and (3) “public morality.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-173",
      "id": "chapter1_173",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("173")])]), _vm._v(" Sometimes the state will need to play a coordinating role, while various civil actors take responsibility for directing various aspects of the common good. Yet, the state may need to undertake a more direct role in some areas, such as public education and overcoming poverty, given their scope and complexity."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-174",
      "id": "chapter1_174",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("174")])]), _vm._v(" Catholicism has long valued the voluntary, independent organizations that make up civil society such as labor unions, neighborhood associations, cooperatives, professional organizations, political parties, etc. The state should not usurp their roles, but rather work in tandem with them. Thus the Catholic understanding of the common good envisions fruitful cooperation between the state and voluntary organizations. The following concept elaborates on this claim.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h3', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Subsidiarity and Socialization")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Both controversial and often misunderstood, the principle of subsidiarity was developed to ensure that governments work in tandem with individuals and local groups to promote the common good."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-175",
      "id": "chapter1_175",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("175")])]), _vm._v(" In other words, subsidiarity protects the right and duty of participation of all in the shaping of and benefiting from the commonweal."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-176",
      "id": "chapter1_176",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("176")])]), _vm._v(" It also points to the obligation of larger entities, such as the state, to help individuals and smaller groups play their part. Persons cannot fulfill their right and duty to participation in the good of society if they suffer from poverty, discrimination, unemployment, untreated illnesses, etc. Both civil society and the state have the "), _c('span', {
    attrs: {
      "aria-label": "36",
      "id": "pg_36",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("responsibility to create the conditions for the full participation of all in the common good. In the words of Pope John XXIII, “intervention of public authorities that encourages, stimulates, regulates, supplements, and complements, is based on "), _c('i', [_vm._v("the principle of subsidiarity")]), _vm._v(".” When possible, it is better for smaller, local groups to solve their own problems.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("However, Catholic social teaching posits that larger entities, including governments, have a responsibility to assist individuals and communities when they cannot effectively solve their own problems. Moreover, for more than fifty years CST has acknowledged an increasing role for the state in socioeconomic affairs as a result of growing complexity and interdependence, a process that CST calls socialization, commonly known today as globalization."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-177",
      "id": "chapter1_177",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("177")])]), _vm._v(" Individuals and local communities can hardly be expected to effectively promote their well-being when globalization has stifled the sovereignty of entire nations."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-178",
      "id": "chapter1_178",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("178")])]), _vm._v(" In the context of this book, it is worth pointing out that the idea of subsidiarity not only applies to the relationship between society and governments, but also to the relationship between employees and employers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-179",
      "id": "chapter1_179",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("179")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h3', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Solidarity")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Solidarity militates against a distorted notion of subsidiarity, which mistakenly purports that charity alone suffices to assuage the suffering of the poor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-180",
      "id": "chapter1_180",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("180")])]), _vm._v(" Solidarity in CST is grounded in natural law, numerous biblical passages, and Christian theological doctrines."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-181",
      "id": "chapter1_181",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("181")])]), _vm._v(" Succinctly stated, the Catholic social tradition postulates three key elements of solidarity: (1) the recognition of human interdependence and corresponding obligations to others that flow from it, especially obligations to the marginalized; (2) a firm commitment to the common good, which requires creating social structures that promote the participation and rights of all; and (3) willingness to work with others across boundaries of class, gender, race, sexual orientation, ethnicity, religion, and nationality to foster an inclusive common good. The first aspect of solidarity entails the recognition that human beings are by nature interdependent. As Franciszek Kampka writes, solidarity involves “the attitude of mutual empathy among members of a community, becoming aware of their deep similarities and interdependence, and deepening them by experiencing the needs of others just as we experience our own needs.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-182",
      "id": "chapter1_182",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("182")])]), _vm._v(" This recognition of a shared humanity "), _c('span', {
    attrs: {
      "aria-label": "37",
      "id": "pg_37",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("and common fate with all people disposes us to attend to “the wounded one and the cry of pain” among us."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-183",
      "id": "chapter1_183",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("183")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The fact of interdependence gives rise to ethical obligations toward others in the personal, social, economic, cultural, political, and religious spheres of social life."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-184",
      "id": "chapter1_184",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("184")])]), _vm._v(" Direct, immediate aid is necessary when a situation gravely threatens a person’s or group’s health, bodily integrity, or psychological well-being. However, solidarity requires moving beyond temporary assistance to “a "), _c('i', [_vm._v("firm and persevering determination")]), _vm._v(" to commit oneself to the common good,” as Pope John Paul II maintained. Solidarity is much more than “a feeling of vague compassion or shallow distress.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-185",
      "id": "chapter1_185",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("185")])]), _vm._v(" It must go beyond short-term aid to be embodied in policies, institutions, and social structures that eliminate the causes of the suffering of the wounded, the poor, and the oppressed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-186",
      "id": "chapter1_186",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("186")])]), _vm._v(" Solidarity seeks to restore to the poor what is rightfully theirs, as those who embody it “recognize that the social function of property and the universal destination of all goods are realities that come before private property.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-187",
      "id": "chapter1_187",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("187")])]), _vm._v(" In other words, solidarity must be “institutionalized” so that all people, including the marginalized, can participate in and benefit from the common good."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-188",
      "id": "chapter1_188",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("188")])]), _vm._v(" Genuine participation entails using one’s abilities and resources to promote both one’s own rights and flourishing, and those of the community."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-189",
      "id": "chapter1_189",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("189")])]), _vm._v(" In this regard, solidarity differs from compassion and almsgiving, which assist passive recipients. Solidarity empowers the marginalized to become active members of the community in order to be able to “bear another’s burdens.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-190",
      "id": "chapter1_190",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("190")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Unlike Weberian, Marxist, and other exclusivist conceptions of solidarity, the Catholic tradition posits the possibility of highly inclusive solidarity across classes, genders, races, religions, and nations."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-191",
      "id": "chapter1_191",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("191")])]), _vm._v(" Catholic thought envisions such communities of solidarity existing on the local, national, and global levels."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-192",
      "id": "chapter1_192",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("192")])]), _vm._v(" In short, the Catholic tradition sees solidarity as both a virtue that individuals should possess and a characteristic of institutions and social relations. Solidarity should shape various aspects of economic, political, and social life both within and among nations. While not denying the possible necessity of conflict for the sake of justice, Catholicism holds that solidarity is possible across the full spectrum of social relations."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-193",
      "id": "chapter1_193",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("193")])]), _vm._v(" In other words, the Catholic ethic of solidarity requires creating and sustaining the common good and the rights of all people on the local, national, and global levels. As "), _c('i', [_vm._v("Gaudium et Spes")]), _vm._v(" states, “solidarity must be continually increased until it is brought to perfection.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-194",
      "id": "chapter1_194",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("194")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h3', {
    staticClass: "H2"
  }, [_c('span', {
    attrs: {
      "aria-label": "38",
      "id": "pg_38",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("Preferential Option for the Poor")])])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Although the scope of solidarity is universal, CST urges a particular solidarity with the poor, oppressed, marginalized, and infirm. CST has adopted the phrase the “preferential option for the poor” to encapsulate this obligation.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The notion of a preferential option for the poor, which John Paul II incorporated into official CST in his 1987 encyclical "), _c('i', [_vm._v("Sollicitudo Rei Socialis")]), _vm._v(", originated in Latin America."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-195",
      "id": "chapter1_195",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("195")])]), _vm._v(" The CELAM (Latin American Episcopal Conference) documents from Medellin (1968) and Puebla (1979) used the term, while liberation theologians Gustavo Gutierrez, Jon Sobrino, Juan Hern"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("á")]), _vm._v("ndez Pico and Archbishop Oscar Romero popularized it in their writings and speeches."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-196",
      "id": "chapter1_196",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("196")])]), _vm._v(" The church’s reading of “the signs of the times,” particularly the widespread poverty in Latin America and throughout the Global South, led to embracing the option for the poor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-197",
      "id": "chapter1_197",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("197")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("While the phrase originated in the latter part of the twentieth century, the idea itself has roots in the Bible and throughout the history of the Christian tradition. As Gustavo Gutierrez wrote in his seminal article on the topic, the biblical texts pointing to the option for the poor are plentiful."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-198",
      "id": "chapter1_198",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("198")])]), _vm._v(" In fact, according to Evangelical theologian Ronald Sider literally hundreds of biblical verses attesting to God’s special attention to the poor fill about two hundred pages."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-199",
      "id": "chapter1_199",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("199")])]), _vm._v(" Powerful writings of the Patristic era, such as those by St. Basil, St. John Chrysostom and Clement of Alexandria, strongly condemn both living a luxurious life and being indifferent to the plight of the poor, who have a right to those goods necessary to survive."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-200",
      "id": "chapter1_200",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("200")])]), _vm._v(" Pope Francis has spoken in a similar vein on numerous occasions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-201",
      "id": "chapter1_201",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("201")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("As John Paul II stated, the church, like the Creator, must adopt “a ‘preferential,’ not exclusive option” for the poor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-202",
      "id": "chapter1_202",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("202")])]), _vm._v(" God loves all people, but just as a parent cares for an ailing child in a special way, God shows particular love for the poor, who have urgent needs. The same can be said of the church’s solicitude. Looking beyond its own ecclesial boundaries, the Catholic tradition goes a step further to maintain that “the poor have the single most urgent economic claim on the conscience of the nation.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-203",
      "id": "chapter1_203",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("203")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Adopting a preferential option for the poor requires us to direct our consumer choices, investment of wealth, talent, and human energy toward this end. It forbids those of us who belong to the upper and middle classes from being blinded by our comfortable lifestyles to the plight of the world’s "), _c('span', {
    attrs: {
      "aria-label": "39",
      "id": "pg_39",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("poor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-204",
      "id": "chapter1_204",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("204")])]), _vm._v(" Like solidarity, the option for the poor must also be embodied in our institutional policies and structures. Making donations or volunteering our time, while meaningful, does not fulfill the Gospel mandate to adopt the option for the poor.")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h3', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Justice")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("The origins of modern Catholic social teaching on justice can be traced back to Aristotle, Aquinas, and later Pius XI, who added the term “social justice” to official CST. The “Social Catholics” in nineteenth-century Europe reacted against the abuses of the workers during the Industrial Revolution by urging that “it is not enough to alleviate the misery of the poor with your gifts. You must go beyond charity to justice.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-205",
      "id": "chapter1_205",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("205")])]), _vm._v(" More recently Pope Benedict XVI argued that charity and justice, which are integrally related, are equally requirements of Christian discipleship. According to the Pope,")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "EXO"
  }, [_c('i', [_vm._v("Charity goes beyond justice")]), _vm._v(", because to love is to give, to offer what is “mine” to the other; but it never lacks justice, which prompts us to give the other what is “his,” what is due to him by reason of his being or his acting. I cannot “give” what is mine to the other, without first giving him what pertains to him in justice. If we love others with charity, then first of all we are just towards them. Not only is justice not extraneous to charity, not only is it not an alternative or parallel path to charity: justice is inseparable from charity and intrinsic to it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-206",
      "id": "chapter1_206",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("206")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Thus, in order to fulfill the command to love the neighbor, the Christian disciple must first help him or her obtain that which all human beings rightfully deserve."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-207",
      "id": "chapter1_207",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("207")])]), _vm._v(" CST elucidates this by pointing to human rights as the minimum demands of justice."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-208",
      "id": "chapter1_208",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("208")])]), _vm._v(" CST also distinguishes between commutative, distributive, and social justice. Commutative justice pertains to justice in exchanges. For example, the worker owes to his or her employer an honest day’s labor, while the employer owes to his or her worker a fair wage for that labor. In Catholic thought, distributive justice requires that the resources of the society are distributed equitably, which means that although differences in wealth and income can be acceptable, at a minimum the basic needs of all persons must first be met. In addition, in accordance with the Patristic notion of the universal destination of all goods, distributive justice implies that all people have a right to those "), _c('span', {
    attrs: {
      "aria-label": "40",
      "id": "pg_40",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("goods necessary for their own and their family’s flourishing. Social justice implies that “persons have an obligation to be active participants in the life of society and that society has a duty to enable them to do so.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-209",
      "id": "chapter1_209",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("209")])]), _vm._v(" Behaviors, laws, policies, and social structures that cause the marginalization of individuals or groups violate the norm of social justice.")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h3', {
    staticClass: "H2"
  }, [_c('i', [_vm._v("Participation")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("The right and duty of participation pervades all of the themes of Catholic social teaching."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-210",
      "id": "chapter1_210",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("210")])]), _vm._v(" Solidarity, justice, subsidiarity, and the common good aim at procuring the right to participation for all, a right that has been explicitly stressed in Catholic social teaching since the 1971 World Synod of Bishops’ document "), _c('i', [_vm._v("Justitia in Mundo")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-211",
      "id": "chapter1_211",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("211")])]), _vm._v(" According to CST, the right to participation functions as the precondition of all other rights. When this right is breached, the realization of all other rights remains in jeopardy."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-212",
      "id": "chapter1_212",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("212")])]), _vm._v(" Empirical evidence shows people must be able to participate substantively in the conversations about their welfare in order to secure their rights and promote the common good."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-213",
      "id": "chapter1_213",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("213")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("In "), _c('i', [_vm._v("Justitia in Mundo")]), _vm._v(" and elsewhere, Catholic social teaching has maintained that all persons have the right and duty to become “principle architects of their own economic and social development.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-214",
      "id": "chapter1_214",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("214")])]), _vm._v(" Participation in this sense entails both the right and duty of every member and numerous groups of a given society to contribute to and benefit from the common good."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-215",
      "id": "chapter1_215",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("215")])]), _vm._v(" Authentic participation contributes to true human flourishing, “the fulfillment of the self,” as Karol Wojty"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ł")]), _vm._v("a put it. Human beings are meant to contribute concretely to the flourishing of the community."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-216",
      "id": "chapter1_216",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("216")])]), _vm._v(" Theologically speaking, authentic participation contributes to the building of the Kingdom of God."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-217",
      "id": "chapter1_217",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("217")])]), _vm._v(" As members of a community, exercising this right and duty requires the willingness to cooperate with others, to make compromises when necessary, and to take seriously the expertise and wisdom of others."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-218",
      "id": "chapter1_218",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("218")])]), _vm._v(" Nonetheless, the very nature and dignity of the human person mandates that those with power or “expertise” should not preclude the meaningful participation of all in the decisions that affect their lives and the good of the community."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-219",
      "id": "chapter1_219",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("219")])]), _vm._v(" The right to participation checks “top-down” decision-making.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("CST specifically emphasizes that all workers have the right to participate in the operations of their workplace in a “fully human way” and to "), _c('span', {
    attrs: {
      "aria-label": "41",
      "id": "pg_41",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("participate in wage and benefit negotiations. Economic processes, including wage and price determinations, must not take place over the heads of workers, especially the poor, whose livelihood depends on them to the largest degree. In short, the right to participation calls for decisions to be made as often as possible by the persons most directly affected by these decisions in the workplace, while also providing them the resources needed to implement these decisions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-220",
      "id": "chapter1_220",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("220")])]), _vm._v(" Later sections of this book will spell out the implications of this teaching for Catholic higher education."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-221",
      "id": "chapter1_221",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("221")])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('samp', {
    staticClass: "SANS_Scala_Sans_Regular_11"
  }, [_vm._v("A Place at the Table for All?")])]), _vm._v(" "), _c('p', {
    staticClass: "TNI"
  }, [_vm._v("Thus far I have emphasized the need to embody the principles and values of CST in institutional policies of Catholic universities. I have discussed this need as a matter of the faith and moral formation of students, coherence with Catholic teaching, and an intrinsic element of evangelization and Christian discipleship. However, what I propose is also a way to promote the rights of all and the common good in higher education. It has been my experience, and continues to be my hope, that all stakeholders at Catholic universities, regardless of their religious affiliation, can find shared values that promote a vision of higher education contrary to the problematic corporatized version. CST can serve as a resource for all who wish to partake in this endeavor, and as a bulwark against the further corporatization of the university.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("By its very nature, CST lends itself to building bridges with people and traditions beyond the Roman Catholic Church. In 1963 Saint John XXIII signaled a major shift in CST with his encyclical "), _c('i', [_vm._v("Pacem in Terris")]), _vm._v(" (Peace on Earth). Never before had a pope addressed an encyclical to “all men ["), _c('i', [_vm._v("sic")]), _vm._v("] of goodwill.” However, John XXIII used this formulation to convey his desire for cooperation among Catholics and non-Catholics alike in the urgent endeavor of peace building."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-222",
      "id": "chapter1_222",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("222")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Catholic social teaching shares much in common with other traditions and universal values. The UN Universal Declaration of Human Rights (UNDHR), which John Paul II deemed “one of the highest expressions of the human conscience of our time,” promotes many of the same rights as CST."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-223",
      "id": "chapter1_223",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("223")])]), _vm._v(" He also affirmed “wide areas of cooperation” between the UN and the church in protecting human rights."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-224",
      "id": "chapter1_224",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("224")])]), _vm._v(" In addition, many of the world’s great religions endorse these same rights, as evidenced by the 1998 Universal "), _c('span', {
    attrs: {
      "aria-label": "42",
      "id": "pg_42",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("Declaration of Human Rights by the World Religions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-225",
      "id": "chapter1_225",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("225")])]), _vm._v(" Workers’ rights, which the next chapter will treat, find support in Islam, Judaism, Buddhism, most major branches of Christianity, and other religions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-226",
      "id": "chapter1_226",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("226")])]), _vm._v(" Despite differences in motivation and interpretations of particular human rights, this convergence has enabled people from many faiths and secular humanists to find common cause in the promotion of human rights throughout the world.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("There is no reason why it should be any different within the confines of a Catholic college or university, where people from various backgrounds share the concern for human rights and the common good. I have witnessed Protestants, Jews, Muslims, Hindus, atheists, and agnostics support the values of CST at Catholic institutions. Given the potency and deep roots of the corporatization of the university, moving to a model of higher education oriented toward human rights and the common good will require support from a broad coalition of people. Catholic colleges and universities need a critical mass of people well versed in the Catholic tradition in order to be able to articulate, explain, and actively promote the Catholic mission and identity of the institutions."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-227",
      "id": "chapter1_227",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("227")])]), _vm._v(" However, as Christian Smith explains, a diverse faculty enables “exchange and engagement” and leads to a “fuller understanding of the truth.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-228",
      "id": "chapter1_228",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("228")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("All faculty, staff, administrators, students, and trustees can broadly support the mission as I have conceived it here if they share core values such as transparency, respect for human dignity and rights, commitment to the common good, and a view of education that rejects corporatization and commodification and promotes human and ecological well-being. There are many allies today in the struggle for justice, solidarity, human rights, and environmental sustainability in higher education. Numerous groups, such as the American Association of University Professors (AAUP), The New Faculty Majority, The Coalition of Contingent Academic Labor (COCAL), the Association of American Colleges and Universities, and The Association for Sustainability in Higher Education (ASHE) espouse many of the priorities for higher education advocated in this book on the basis of Catholic social teaching. Although I cannot systematically explore their continuity with CST, later chapters will feature some of these groups."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-229",
      "id": "chapter1_229",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("229")])]), _vm._v(" Building diverse alliances around shared goals and values is crucial to the task this book advocates.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Many, if not most mission statements of Catholic universities, advert to key themes of CST, such as social justice, solidarity, and the common "), _c('span', {
    attrs: {
      "aria-label": "43",
      "id": "pg_43",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("good. Therefore, undertaking the task I am advocating in this book is also a matter of truthfulness (or to put it in terms of the lingua franca of the corporatized university, “truth in advertising”). When these mission statements function as little more than slogans, students, faculty, and staff become jaded toward the institution. Already the 1967 Land O’Lakes statement, signed by representatives of several of the nation’s most influential Catholic universities, recognized the need “to practice what we preach”:")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "EXO"
  }, [_vm._v("The total organization should reflect this same Christian spirit. The social organization should be such as to emphasize the university’s concern for persons as individuals and for appropriate participation by all members of the community of learners in university decisions. University decisions and administrative actions should be appropriately guided by Christian ideas and ideals and should eminently display the respect and concern for persons."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-230",
      "id": "chapter1_230",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("230")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("If what I have argued is correct, living up to this idea of the Catholic university is a matter of institutional fidelity. It is a matter of what heroic dissidents like V"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("á")]), _vm._v("clav Havel, the agnostic writer and eventual president of Czechoslovakia, and Adam Michnik, a Polish Jew and historian, called “life in truth.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-231",
      "id": "chapter1_231",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("231")])]), _vm._v(" The Polish labor priest and martyr Blessed Jerzy Popie"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ł")]), _vm._v("uszko maintained that living a life in truth meant living in accordance with one’s conscience."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-232",
      "id": "chapter1_232",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("232")])]), _vm._v(" The solidarity of consciences, the deepest kind of solidarity, calls everyone to be a person of conscience."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-233",
      "id": "chapter1_233",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("233")])]), _vm._v(" For the heroes of the Velvet Revolution and Solidarno"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ść")]), _vm._v(", being a person of conscience did not necessarily require explicit belief in God. However, life in truth required defending a view of the human person as one imbued with inviolable dignity and the capacity and obligation to realize freedom in solidarity with others for the common good. This shared anthropology allowed for Christians, Jews, atheists, and agnostics to unite in a common cause that respected but transcended their differences."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-234",
      "id": "chapter1_234",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("234")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Havel and Michnik, like many other dissidents, were tortured and jailed for years. Havel nonetheless insisted: “I am not on the side of any establishment.… I merely take the side of truth against lies, the side of sense against nonsense, the side of justice against injustice.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-235",
      "id": "chapter1_235",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("235")])]), _vm._v(" Michnik regretted that many Poles supported the Communist regime out of fear. However, with the rise of Solidarity, Poles began to “spit out the gag” by expressing their opposition. No longer would they live a lie, which, according to Michnik, "), _c('span', {
    attrs: {
      "aria-label": "44",
      "id": "pg_44",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("“establish[es] all of one’s relations with other people as relations based on pretence.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-236",
      "id": "chapter1_236",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("236")])]), _vm._v(" Popie"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ł")]), _vm._v("uszko paid for his commitment to truth with his life. He had insisted that preserving one’s own human dignity required standing by “the truth in all situations in life … even if this is going to cost us dearly.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-237",
      "id": "chapter1_237",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("237")])]), _vm._v(" Lying causes the human person to become “a slave” and “debases” human dignity. Popie"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ł")]), _vm._v("uszko, like John Paul II, believed that human freedom is attained above all by living in accordance with the truth."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-238",
      "id": "chapter1_238",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("238")])]), _vm._v(" In the US context, Black freedom fighters like Dr. Martin Luther King Jr. and Malcolm X held similar views. King, for example, stated that a person “dies when he ["), _c('i', [_vm._v("sic")]), _vm._v("] refuses to take a stand for that which is true.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-239",
      "id": "chapter1_239",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("239")])]), _vm._v(" Like King, Malcolm X’s unwavering pursuit of truth led to his death. Shortly before his demise, he penned words worthy of pondering today: “I’ve had enough of someone else’s propaganda.… I’m for truth, no matter who tells it. I’m for justice, no matter who it is for or against.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-240",
      "id": "chapter1_240",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("240")])]), _vm._v(" Elizabeth Cady Stanton also affirmed the relationship between truth, dignity, and life itself. In her words, “The moment we begin to fear the opinions of others and hesitate to tell the truth that is in us, and from motives of policy are silent when we should speak, the divine floods of light and life no longer flow into our souls.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-241",
      "id": "chapter1_241",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("241")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Put another way, living a lie constitutes living an inauthentic life. Charles Taylor notes that the notion of authenticity resonates today because of the emphasis on self-fulfillment and being true to oneself in our time. However, Taylor contends that authenticity requires transcending the self and fostering solidarity with others. His point echoes CST’s call to solidarity as a means of self-fulfillment, as well as Havel’s insistence on commitment to something greater than—transcendent to—ourselves:")]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "EXO"
  }, [_vm._v("The agent seeking significance in life, trying to define him or herself meaningfully, has to exist in a horizon of important questions.… Only if I exist in a world in which history, or the demands of nature, or the needs of my fellow human beings, or the duties of citizenship, or the call of God, or something else of this order matters crucially, can I define an identity for myself that is not trivial. Authenticity is not the enemy of demands that emanate from beyond the self; it supposes such demands."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-242",
      "id": "chapter1_242",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("242")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The context of the corporatized university may not be as menacing as what Havel, Michnik, Popie"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ł")]), _vm._v("uszko faced in Communist Eastern Europe "), _c('span', {
    attrs: {
      "aria-label": "45",
      "id": "pg_45",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("or what King, Malcolm X, or Cady Stanton confronted in their racist, misogynistic society. Nonetheless, their words and witness serve as a lodestar. Living in truth at Catholic colleges and universities requires all to commit themselves to the basic values of the institution’s mission. It is a matter of authenticity. As I have stressed, many members of Catholic higher educational communities willingly and admirably promote the values of CST. On the other hand, many have chosen to attend or to work at Catholic colleges and universities for reasons that have nothing to do with the university’s task to promote solidarity, human rights, and the common good."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-243",
      "id": "chapter1_243",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("243")])]), _vm._v(" However, when we at Catholic institutions fail to try to support the basic values of the university’s mission, we resemble the shopkeeper in Havel’s famous work, "), _c('i', [_vm._v("The Power of the Powerless")]), _vm._v(", who displays a sign from the Communist Party in his window solely because he wants to maintain his relatively comfortable life."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-244",
      "id": "chapter1_244",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("244")])]), _vm._v(" All members of a Catholic higher educational community—regardless of their religious affiliation—should search their consciences and stand up for the values of the university’s mission that they can in good faith promote, rather than remain in their silos or become “gated intellectuals.” They should “spit out the gag” by denouncing the corporatized university as anathema and by calling for a university that actualizes the vision of social life proffered by CST. They should defend the notion that the raison d’"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ê")]), _vm._v("tre of higher education is to promote the “whole development of the person” and the common good."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-245",
      "id": "chapter1_245",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("245")])]), _vm._v(" While this may require sacrifice, it will ultimately be rewarding. As Michnik maintained, “you score a victory not when you win power but when you remain faithful to yourself.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-246",
      "id": "chapter1_246",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("246")])]), _vm._v(" Those who believe that higher education should be marked by cutthroat competition, bottom-line thinking harmful to people or the planet, elitism, conspicuous consumption, and market-driven rewards and punishments ought to consider whether their conscience allows them to work at a Catholic college or university."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-247",
      "id": "chapter1_247",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("247")])]), _vm._v(" We must also be aware, as Keri Day warns, that to be a “witness to truth” in the present moment challenges us because “neoliberal forces breed a sense of apathy and inefficacy in us that we can transform broader society.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-248",
      "id": "chapter1_248",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("248")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Christians working in the academy must not “check their discipleship” at the entrance gate to the university. In this connection, it is worth recalling Vatican II’s exhortation to overcome the “split between the faith which many profess and their daily lives,” which is “among the more serious errors of our age.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-249",
      "id": "chapter1_249",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("249")])]), _vm._v(" Popie"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ł")]), _vm._v("uszko put the matter starkly: “You will not "), _c('span', {
    attrs: {
      "aria-label": "46",
      "id": "pg_46",
      "role": "doc-pagebreak"
    }
  }, [_vm._v("preserve your full dignity by carrying around the rosary in one pocket and a little book of totally contrary ideology in the other. You cannot, at one and the same time, serve God and Mammon … you have to make a choice.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-250",
      "id": "chapter1_250",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("250")])]), _vm._v(" Christians are thus always obliged to ask, in accordance with Jesus’s command to love the neighbor, who are the people “lying on the road” in our midst (see Lk. 10:25–38)? They must contemplate how to act analogously to the Samaritan in the context of corporatized higher education."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-251",
      "id": "chapter1_251",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("251")])]), _vm._v(" Discipleship, which may entail personal cost to those who challenge the entrenched bureaucracy of corporatized universities, requires overturning “power structures in … our communities, as well as an equitable distribution of resources and fuller participation in communal life.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-252",
      "id": "chapter1_252",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("252")])]), _vm._v(" Discipleship demands “faithfulness” to the Gospel, not focusing on “success.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-253",
      "id": "chapter1_253",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("253")])]), _vm._v(" In other words, Christian disciples must be ready to fail in the face of resistance to the Gospel, while striving to embody “Jesus’ way as concrete and specific guidance to be followed” rather than a “vague ideal or principle … or teaching ideals too high to actually put into practice.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-254",
      "id": "chapter1_254",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("254")])])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Traversing the trail from the modern corporatized university will be steep and treacherous at times, but CST provides clear guidance along this path. Implementing CST in their policies and practices might also make Catholic colleges and universities more competitive. For example, they might be in a better position to appeal to potential students and donors who wish to support egalitarianism and social justice. Institutions such as Berea College have been able to connect with benefactors who want to support its mission to provide high quality education for the economically disadvantaged. Catholic universities, on the other hand, have done a relatively poor job of soliciting gifts exclusively for the purpose of promoting the values and principles of Catholic social teaching on our campuses. Embodying the vision of Catholic social teaching is challenging and costly, particularly at this time of financial uncertainty for many institutions. Yet, there is greater potential for Catholic universities to focus on their mission, and real risks to failing to try. As the Carnegie Council study “Three Thousand Futures” augured, only “those universities that have a well-defined and well implemented sense of identity will survive and thrive.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#chapter1-255",
      "id": "chapter1_255",
      "role": "doc-noteref",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("255")])])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("Having elaborated the context and rationale for my analysis, I will now turn to issues that require sustained efforts in order to pursue our mission as Catholic institutions in good faith.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5739cb62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 84
// module chunks = 0